import React from "react"
import Highlight, { defaultProps } from "prism-react-renderer"
import Prism from "prismjs"

import style from "../style/prism.css"

import localStyle from "./style/rendererblock.module.css"

/*import Prism from "prism-react-renderer/prism";

(typeof global !== "undefined" ? global : window).Prism = Prism;*/

require('prismjs/components/prism-javascript')
require('prismjs/components/prism-bash');
require('prismjs/components/prism-c');
require('prismjs/components/prism-jsx');
require('prismjs/components/prism-json')

let shellPrompt = {
    type: 'generic',
    user: 'user',
    host: 'host',
    psPath: 'C:\\',
    custom: '$'
}

export default (props) => {

    const language = (props.className)
        ? props.className.replace(/^language-/, '')
        : 'none'

    const linestart = props.linestart ? parseInt(props.linestart) : 1;

    const tags = [];

    const matchDelimiter = (tokenString) => {
        if (tokenString.match(/^\$ */) != null) return true; else return false;
    }

    if (props.prompt) {
        if (typeof props.prompt === 'string') {
            setShellPrompt({type: props.prompt})
        }
    }

    const filepathString = (props.prompt)
        ? (shellPrompt.type === 'unix')
            ? 'unix shell'
            : (shellPrompt.type === 'ps')
                ? 'powershell'
                : (shellPrompt.type === 'generic')
                    ? 'shell'
                    : shellPrompt.type
        : (props.filepath)
            ? props.filepath
            : ''

    const filepath = filepathString 
        ? <span className={localStyle.filepath}>{filepathString}</span>
        : null

    // TODO: refactor as a table so line wrapping works properly
    // TODO: make filepath go above the block when the width is too small

    return (
        <div className={localStyle.container}>
	    <pre className={`text-mono`}>
			{filepath}
	    </pre>
            <Highlight Prism={Prism} code={props.children} language={language} theme={undefined}>
                {({className, style, tokens, getLineProps, getTokenProps}) => (
                        <pre className={`${className} text-mono`} style={{...style, paddingLeft: '0', position: 'relative'}}>
                            <div style={{ overflowX: 'auto', overflowY: 'hidden'}}>
                                <table>
                                    <tbody>
                                        {(tokens.map((line, idx) => {

                                            if (line.length === 1 && line[0].empty) return null;

                                            let tagtext = null;

                                            if (props.prompt) {
                                                if (matchDelimiter(line[0].content)) {
                                                    tagtext = ' ';
                                                } else {
                                                    tagtext = getShellPrompt();
                                                }
                                            } else if (props.linenumbers) {
                                                tagtext = `${idx+linestart}`;
                                            }

                                            const tag = (tagtext !== null) 
                                                ? <span className="command-line-prompt">{tagtext}</span>
                                                : null;

                                            const codeline = (
                                                <code>
                                                    <div key={idx}  {...getLineProps({line, key: idx})}>
                                                        {(props.prompt && matchDelimiter(line[0].content))
                                                            ? line.map((token,key) => key != 0 ? <span key={key} {...getTokenProps({token, key})} className={""}/> : null)
                                                            : (line.length === 1 && line[0].empty)
                                                                ? null
                                                                : line.map((token, key) => <span key={key} {...getTokenProps({token, key})}/>)
                                                        } 
                                                    </div>
                                                </code>
                                            )

                                            return (
                                                <tr>
                                                    {tag ? <td className={`${localStyle.tag} ${localStyle.nowrap}`}>{tag}</td> : null}
                                                    <td className={`${localStyle.codeline}`} style={{ whiteSpace: (props.prompt) ? 'pre-wrap' : 'pre'}}>{codeline}</td>
                                                </tr>
                                            );
                                        }))}
                                
                                    </tbody>
                                </table>
                            </div>
                        </pre>
                )}
            </Highlight>
        </div>

    )
}

// style={{position: 'absolute', top: 0, left: "-100px", width: '80px', userSelect: 'none', borderRight: '1.5px solid #ccc'}}

export const setShellPrompt = (promptConfig) => {
    if (promptConfig.user)
        shellPrompt.user = prompt.user;
    
    if (promptConfig.host)
        shellPrompt.host = prompt.host;
    
    if (promptConfig.type)
        shellPrompt.type = promptConfig.type;
    
    if (promptConfig.psPath)
        shellPrompt.psPath = promptConfig.psPath;
    
    if (promptConfig.custom)
        shellPrompt.custom = promptConfig.custom;
}

const getShellPrompt = () => {
    if (shellPrompt.type === 'unix') 
        return `[${shellPrompt.user}@${shellPrompt.host}] ${shellPrompt.user === 'root' ? '#' : '$'}`
    else if (shellPrompt.type === 'ps')
        return `${shellPrompt.psPath}`
    else 
        return `${shellPrompt.custom}`
}
